import React, { createContext, useState } from 'react';
import { addDays } from '../utils/helpers';

const EventsOverviewFilterContext = createContext();

function EventsOverviewFilterProvider(props) {
  const [calendarViewActive, setCalendarViewActive] = useState(false);
  const [filterOnlyBooked, setFilterOnlyBooked] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [limit, setLimit] = useState(10);
  const [toDate, setToDate] = useState(addDays(new Date(), 180));
  const [selectedMandants, setSelectedMandants] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState(null);
  const [offset, setOffset] = useState(0);

  return (
    <EventsOverviewFilterContext.Provider
      value={{
        calendarViewActive,
        setCalendarViewActive,
        filterOnlyBooked,
        setFilterOnlyBooked,
        fromDate,
        setFromDate,
        limit,
        setLimit,
        toDate,
        setToDate,
        selectedMandants,
        setSelectedMandants,
        selectedCourses,
        setSelectedCourses,
        offset,
        setOffset,
      }}>
      {props.children}
    </EventsOverviewFilterContext.Provider>
  );
}

export { EventsOverviewFilterProvider, EventsOverviewFilterContext };
